<template>
    <div class="pcp_intro_content" v-show="isShow">
        <div class="intro_content">
            <div v-swiper:bannerSwiper="swiperOptions" class="swiper-container swiper-container2 swiper-container-horizontal"
            v-if="item.bannerItems&&item.bannerItems.length>1"
            >
                <div class="swiper-wrapper">
                    <div class="swiper-slide" style="width: 351px;" v-for="(banner, i) in item.bannerItems" :key="('banner_'+i)">
                        <div class="intro_headImg">
                            <img class="headImg"
                                :src="banner">
                        </div>
                    </div>
                    
                </div>

                <div class="swiper-button-prev" @click="bannerImageChange('prev')"></div>
                <div class="swiper-button-next" @click="bannerImageChange('next')"></div>
            </div>

            <div v-else-if="item.bannerItems&&item.bannerItems.length==1">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="intro_headImg">
                                <img class="headImg"
                                    :src="item.bannerItems[0]">
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="room_detail scroll-container">
                <div class="room_detail-topCon">
                    <div class="room_detail-name">{{item.name}}</div>
                    <div class="room_detail-seeVRBtn">
                        <span>{{item.briefTitle}}</span>
                        <a class="external seeVrShow" v-if="shipCode!=='SC'&&item.vrUrl&&item.vrUrl.length>0"
                            :href="item.vrUrl" target="_blank">
                            <img src="https://resource.rcclchina.com.cn/shipDetail/VRIcon.png">
                        </a>
                    </div>
                </div>
                <div class="room_detail-pcpIntro">
                    <div class="Rboard Brief1 Brief" v-if="item.brief1&&item.brief1.length>0" :style="briefStyle(item.brief1)">
                        <div class="RboardImg BriefImg"></div>
                        <div class="RboardWr BriefText">{{item.brief1}}</div>
                    </div>
                    <div class="Rcontain Brief2 Brief" v-if="item.brief2&&item.brief2.length>0" :style="briefStyle(item.brief2)">
                        <div class="RcontainImg BriefImg"></div>
                        <div class="RcontainWr BriefText">{{item.brief2}}</div>
                    </div>
                    <div class="RConsume Brief3 Brief" v-if="item.brief3&&item.brief3.length>0" :style="briefStyle(item.brief3)">
                        <div class="RconsumeImg BriefImg"></div>
                        <div class="RconsumeWr BriefText">{{item.brief3}}</div>
                    </div>
                    <div class="RDressing Brief4 Brief" v-if="item.brief4&&item.brief4.length>0" :style="briefStyle(item.brief4)">
                        <div class="RdressingImg BriefImg"></div>
                        <div class="RdressingWr BriefText">{{item.brief4}}</div>
                    </div>
                    <div class="RTiming Brief5 Brief" v-if="item.brief5&&item.brief5.length>0" :style="briefStyle(item.brief5)">
                        <div class="RtimingImg BriefImg"></div>
                        <div class="RtimingWr BriefText">{{item.brief5}}</div>
                    </div>
                    <div class="Brief6 Brief " v-if="item.brief6&&item.brief6.length>0" :style="briefStyle(item.brief6)">
                        <div class="BriefImg"></div>
                        <div class="BriefText">{{item.brief6}}</div>
                    </div>
                    <div class="Brief7 Brief " v-if="item.brief7&&item.brief7.length>0" :style="briefStyle(item.brief7)">
                        <div class="BriefImg"></div>
                        <div class="BriefText">{{item.brief7}}</div>
                    </div>
                    <div class="Brief8 Brief " v-if="item.brief8&&item.brief8.length>0" :style="briefStyle(item.brief8)">
                        <div class="BriefImg"></div>
                        <div class="BriefText">{{item.brief8}}</div>
                    </div>
                    <div class="Brief9 Brief" v-if="item.brief9&&item.brief9.length>0" :style="briefStyle(item.brief9)">
                        <div class="BriefImg"></div>
                        <div class="BriefText">{{item.brief9}}</div>
                    </div>
                </div>

                <div class="room_detail-shipsName" v-if="shipTags.length>0">
                    <div class="Qnov">
                        <div class="QnovWrLeft">您可在</div>
                        <div class="QnovShips">
                            <div class='QnovLeft' v-for="(ship, i) in shipTags" :key="('ship_'+i)">
                                <a class='external' :href='ship.link'>
                                    {{ship.name}}
                                </a>
                            </div>
                        </div>
                        <div class="QnovWrRight">上体验该设施。</div>
                    </div>
                </div>
                <div class="room_detail-info">
                    {{item.description}}
                </div>
                <div class="room_detail-pcpOrder" v-if="item.showPcp&&item.pcpUrl">
                    <div class="room_detail-pcpOrderL">
                        <p>预订船票后</p>
                        <p>可至“皇家行前订”预订该项目</p>
                    </div>
                    <div class="room_detail-pcpOrderR">
                        <a class="external"
                            :href="item.pcpUrl">皇家行前订</a></div>
                </div>

            </div>
            <div v-if="shipCode==='SC' && item.vrUrl && item.vrUrl.length>0" class="viewVrMiniSite">
              <a :href="'https://mobile.rcclchina.com.cn/'+item.vrUrl" target="_blank">
                <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/vrImg/vrBtn.png" alt="">
              </a>
            </div>
            <div class="close" @click="onClose"><img src="https://resource.rcclchina.com.cn/Faq/closed.png" class=""></div>
        </div>
    </div>
</template>

<script>
import { directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
    name: "ShipExperiencePopup",
    directives: {
        swiper: directive
    },
    props: {
        item: {
            type: Object,
            default () {
                return {}
            }
        },
        isShow: {
            type: Boolean,
            default () {
                return false
            }
        },
        onClose: {
            type: Function
        },
        ships: {
            type: Array,
            default () {
                return []
            }
        }
    },
    data () {
        return {
            swiperOptions: {
                loop: true
            },
            shipCode:''
        }
    },
  methods: {
        bannerImageChange(slide) {
            if (slide == 'prev') {
                this.bannerSwiper.slidePrev()
            } else {
                this.bannerSwiper.slideNext()
            }
        },
        briefStyle (briefText) {
            if (briefText && briefText.length >= 13) {
                return { 'width': '100%'}
            }
            return {}
        }
    },
    computed: {
        shipTags () {
            if (!this.item.ships || this.item.ships.length == 0) {
                return []
            }
            let ships = []
            this.item.ships.split(',').forEach(shipName => {
                const ship = this.ships.find(r=>r.shipCNName==shipName)
                if (ship) {
                    ships.push({
                        name: shipName,
                        link: `/content/taste/ships/${ship.shipCode}`
                    })
                  this.shipCode = ship.shipCode
                }
            })
            return ships
        }
    }
}
</script>

<style lang="less" scoped>
.pcp_intro_content {
    background-color: rgba(0,0,0,.6);
    position: fixed;
    top: 0;
    z-index: 1111;
    height: 100%;
    width: 100%;
    .intro_content {
        width: 93.6%;
        left: 3.2%;
        position: relative;
        top: 66px;
        background-color: #fff;
        color: #000;
        padding-bottom: 25px;
        .swiper-container {
            padding-bottom: 10px;
            .swiper-button-prev, .swiper-button-next {
                top: 50%;
                transform: scale(.5);
                -webkit-transform: scale(.5);
                -moz-transform: scale(.5);
                -o-transform: scale(.5);
            }
            .intro_headImg {
                width: 100%;
                /* height: 175px; */
                overflow: hidden;
                .headImg {
                    width: 130%;
                    position: relative;
                    left: -23%;
                }
            }
        }

        .room_detail {
            padding-left: 10px;
            padding-right: 10px;
            height: 240px;
            overflow-y: scroll;
            .room_detail-topCon {
                overflow: hidden;
                border-bottom: 1px dotted #eee;
                padding-bottom: 6px;
                .room_detail-name {
                    float: left;
                    color: #000F57;
                    font-size: 13px;
                    font-weight: 600;
                    margin-top: 4px;
                }
                .room_detail-seeVRBtn {
                    float: right;
                    span {
                        color: #333;
                        font-size: 13px;
                        margin-right: 6px;
                        vertical-align: middle;
                    }
                    a {
                        color: #000;
                        text-decoration: none;
                        img {
                            width: 30px;
                            height: 30px;
                            vertical-align: middle;
                        }
                    }
                }
            }
            .room_detail-pcpIntro {
                clear: both;
                margin-top: 12px;
                overflow: hidden;
                .Brief {
                    font-size: 12px;
                    margin-top: 10px;
                    margin-right: 1%;
                    float: left;
                    width: 49%;
                    .BriefImg {
                        width: 17px;
                        height: 18px;
                        float: left;
                        background-size: 100%;
                        margin-top: 2px;
                        margin-right: 4px;
                    }
                    .BriefText {
                        font-size: 12px;
                        float: left;
                        margin-top: 4px;
                        width: 86%;
                    }
                }
                .Brief1 {
                    .BriefImg {
                        width: 15px;
                        height: 11px;
                        background: url('https://resource.rcclchina.com.cn/shipDetail/boardIcon.png') no-repeat;
                        background-size: 100%;
                        margin-right: 4px;
                        margin-top: 6px;
                    }
                }
                .Brief2 {
                    .BriefImg {
                        width: 17px;
                        height: 12px;
                        background: url('https://resource.rcclchina.com.cn/shipDetail/containIcon.png') no-repeat;
                        background-size: 100%;
                        margin-right: 4px;
                        margin-top: 6px;
                    }
                }
                .Brief3 {
                    .BriefImg {
                        width: 12px;
                        height: 15px;
                        background: url('https://resource.rcclchina.com.cn/shipDetail/consumeIcon.png') no-repeat;
                        background-size: 100%;
                        margin-right: 4px;
                        margin-top: 6px;
                    }
                }
                .Brief4 {
                    .BriefImg {
                        width: 15px;
                        height: 12px;
                        background: url('https://resource.rcclchina.com.cn/shipDetail/menuIcon.png') no-repeat;
                        background-size: 100%;
                        margin-right: 4px;
                        margin-top: 6px;
                    }
                }
                .Brief5 {
                    .BriefImg {
                        width: 15px;
                        height: 15px;
                        float: left;
                        background: url('https://resource.rcclchina.com.cn/shipDetail/timeImg.png') no-repeat;
                        background-size: 100%;
                        margin-right: 4px;
                        margin-top: 6px;
                    }
                }
                .Brief6 {
                    .BriefImg {
                        background: url(https://resource.rcclchina.com.cn/rcclQN/mobile/01.png) no-repeat;
                        background-size: 100%;
                    }
                }
                .Brief7 {
                    .BriefImg {
                        background: url(https://resource.rcclchina.com.cn/rcclQN/mobile/02.png) no-repeat;
                        background-size: 100%;
                    }
                }
                .Brief8 {
                    .BriefImg {
                        background: url(https://resource.rcclchina.com.cn/rcclQN/mobile/03.png) no-repeat;
                        background-size: 100%;
                    }
                }
                .Brief9 {
                    .BriefImg {
                        background: url(https://resource.rcclchina.com.cn/rcclQN/mobile/04.png) no-repeat;
                        background-size: 100%;
                    }
                }
            }
            .room_detail-shipsName {
                margin-top: 18px;
                clear: both;
                font-size: 12px;
                .Qnov {
                    color: #000;
                    > div {
                        display: inline-block;
                        vertical-align: middle;
                    }
                    .QnovLeft {
                        display: inline-block;
                        vertical-align: middle;
                        background-color: #006AB7;
                        border-radius: 6px;
                        color: #fff;
                        font-size: 12px;
                        padding: 2px 6px;
                        margin-right: 2px;
                        margin-left: 2px;
                        a {
                            display: inline-block;
                            color: #fff;
                            text-decoration: none;
                        }
                    }
                }
            }
            .room_detail-info {
                line-height: 20px;
                color: #999;
                font-size: 12px;
                margin-top: 21px;
                margin-bottom: 11px;
            }
            .room_detail-pcpOrder {
                clear: both;
                overflow: hidden;
                padding-top: 8px;
                padding-bottom: 8px;
                border-top: 1px dotted #eee;
                .room_detail-pcpOrderL {
                    float: left;
                    text-align: center;
                    p {
                        color: #333;
                        font-size: 13px;
                        margin: 0;
                    }
                }
                .room_detail-pcpOrderR {
                    float: right;
                    color: #fff;
                    font-size: 12px;
                    background-color: #f5b411;
                    width: 115px;
                    height: 33px;
                    line-height: 33px;
                    text-align: center;
                    margin-top: 4px;
                    a {
                        width: 100%;
                        height: 100%;
                        display: inline-block;
                        color: #fff;
                        text-decoration: none;
                    }
                }
            }

        }
        

        .close {
            position: absolute;
            right: 5px;
            top: 5px;
            width: 23px;
            height: 23px;
            z-index: 1111;
            img {
                width: 100%;
            }
        }
    }
}
.viewVrMiniSite{
  width: 176px;
  height: 41px;
  margin: 10px auto 0;
  overflow: hidden;
  background-color: #fbbb02;
  & img{
    width: 100%;
    height: 100%;
  }

}
</style>